import React from "react";
import { ShieldCheck, Hand, BadgeCheck, Truck } from "lucide-react";

const FEATURES = [
  { icon: ShieldCheck, title: "Authentic Ilkal Sarees", text: "Sourced directly from weaver families in Ilkal, Karnataka — genuine GI-tradition handloom, never powerloom imitations." },
  { icon: Hand, title: "Traditional Craftsmanship", text: "Woven on traditional pit looms with the signature Ilkal temple border and contrast pallu techniques." },
  { icon: BadgeCheck, title: "Quality Checked", text: "Every saree is inspected thread by thread for weave, colour fastness and finish before it ships to you." },
  { icon: Truck, title: "Pan India Delivery", text: "Carefully packed and shipped from Ilkal to every corner of India, with easy WhatsApp support." },
];

export const WhyUs = () => (
  <section className="py-12 sm:py-16 bg-surface" data-testid="why-us-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold text-center">The R V promise</p>
      <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3 text-center">Why Choose Us</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 mt-8">
        {FEATURES.map((f) => (
          <div key={f.title} className="bg-ivory border border-gold/25 p-8 sm:p-10 hover:border-gold/60 transition-colors" data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <f.icon className="w-8 h-8 text-maroon" strokeWidth={1.25} />
            <h3 className="font-heading text-xl text-charcoal mt-5">{f.title}</h3>
            <p className="text-sm text-charcoal/60 leading-relaxed mt-3">{f.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
